/**
 * @fileoverview ESM view of the ONE reading-language rule (PAYDAY-UAT-REMEDIATION-001 U8 W8-5).
 * @module @puffin-core/i18n-bootstrap/esm/readingLanguage
 *
 * **There is no logic in this file.** The implementation lives once, in CJS, at `../readingLanguage.js`: see that file
 * for the rule and for why the source direction is CJS. Destructured default import, the `./languageCode.js` form.
 */

import readingLanguage from '../readingLanguage.js';

export const {
  BUNDLED_LANGUAGE_CODES,
  DEFAULT_LANGUAGE,
  resolveShippedLanguage,
  readingLanguageOf,
} = readingLanguage;
